import { buildHomepageStructuredData } from "./HomepageStructuredDataSchema";
import { buildWebPageStructuredData } from "./WebPageStructuredDataSchema";
import {
  buildNewsArticleStructuredData,
  getActiveAuthors,
} from "./AuthorStructuredDataSchema";

type PageStory = {
  content?: {
    author?: unknown;
    component?: string;
    og_title?: string;
    og_description?: string;
    body?: unknown;
    title?: string;
    overview_title?: string;
    photos?: { asset?: { filename?: string } }[];
    og_image?: { filename?: string };
    date?: string;
    overview_published_date?: string;
  };
  first_published_at?: string;
  published_at?: string;
};

type LayoutStructuredDataInput = {
  isHomepage: boolean;
  headerContent: {
    organization?: { name?: string }[];
  } | null | undefined;
  pageStory: PageStory | null | undefined;
  pageUrl: string;
  baseURL: string;
  genericNewsTemplates: string[];
  authorOverrideToPersonTemplates: string[];
};

export const buildLayoutStructuredDataSeo = ({
  isHomepage,
  headerContent,
  pageStory,
  pageUrl,
  baseURL,
  genericNewsTemplates,
  authorOverrideToPersonTemplates,
}: LayoutStructuredDataInput) => {
  const pageContent = pageStory?.content;
  const component = pageContent?.component;
  const isGenericNews =
    !!component && genericNewsTemplates.includes(component);
  const inAuthorOverride =
    !!component && authorOverrideToPersonTemplates.includes(component);
  const authors = inAuthorOverride
    ? getActiveAuthors(pageContent?.author)
    : [];
  const organizationName = headerContent?.organization?.[0]?.name;

  const homepage = isHomepage
    ? JSON.stringify(
        buildHomepageStructuredData(headerContent, pageContent, baseURL)
      )
    : null;

  const webPage =
    !isHomepage && component && !isGenericNews
      ? JSON.stringify(
          buildWebPageStructuredData(
            headerContent,
            pageContent,
            pageStory,
            pageUrl,
            baseURL,
            inAuthorOverride ? authors : undefined
          )
        )
      : null;

  const newsArticle =
    !isHomepage && isGenericNews && pageContent
      ? JSON.stringify(
          buildNewsArticleStructuredData(
            pageContent as Parameters<typeof buildNewsArticleStructuredData>[0],
            baseURL,
            authors,
            organizationName
          )
        )
      : null;

  return { homepage, webPage, newsArticle };
};
